module.exports = __webpack_public_path__ + "static/media/report.d1840ee0.png";